import { SvgIcon } from "@material-ui/core";
import React from "react";

const NutritionIcon = (props) => {
  return (
    <SvgIcon
      style={{
        fontSize: 24,
      }}
      {...props}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.29 35.4">
        <path d="M25.55,12a9.86,9.86,0,0,0-10.41.09A9.87,9.87,0,0,0,1.44,25.55l4.26,7a6,6,0,0,0,9.44,1,6,6,0,0,0,9.45-1l4.25-7A9.87,9.87,0,0,0,25.55,12Z" />
        <path d="M7.31,1.75A1.83,1.83,0,0,1,9.06,0a7.06,7.06,0,0,1,7.4,7.4,1.83,1.83,0,0,1-1.74,1.75A7.09,7.09,0,0,1,7.31,1.75Z" />
      </svg>
    </SvgIcon>
  );
};

export default NutritionIcon;
